import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'se-printing-cd-status-renderer',
    templateUrl: './printing-cd-status-renderer.component.html',
    styleUrls: ['./printing-cd-status-renderer.component.scss'],
    standalone: false
})
export class PrintingCdStatusRendererComponent implements ICellRendererAngularComp {
    working: boolean = false;
    success: boolean = false;
    failure: boolean = false;
    warning: boolean = false;

    constructor() {
        // Comment inserted for compliant code
    }

    refresh(params): boolean {
        this.updateParams(params);

        return true;
    }

    agInit(params): void {
        this.updateParams(params);
    }

    private updateParams(params) {
        switch (params.value) {
            case 1:  // "IDLE";
            case 2: // "PENDING";
            case 3: // "CREATING";
            case 8: // "WAITING";
            case 9: // "BURNER";
                this.working = true;
                this.failure = false;
                this.success = false;
                this.warning = false;
                break;
            case 4: // "DONE";
                this.working = false;
                this.failure = false;
                this.success = true;
                this.warning = false;
                break;
            case 6: // "BLOCKED";
                this.working = false;
                this.failure = false;
                this.success = false;
                this.warning = true;
                break;
            case 5: // "FAILED";
            case 7: // "ABORTED";
            default: // "UNKNOWN";
                this.working = false;
                this.failure = true;
                this.success = false;
                this.warning = false;
                break;
        }

    }
}
